// Central endpoint config — supports both:
//  (a) FastAPI backend deploy (REACT_APP_BACKEND_URL points to https://…)
//  (b) Static/cPanel deploy (REACT_APP_BACKEND_URL empty ⇒ use bundled PHP handler)
const RAW = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const IS_STATIC_DEPLOY = !RAW;
export const API_ROOT = RAW;

export const APPLY_URL = IS_STATIC_DEPLOY
  ? "api/apply.php"
  : `${API_ROOT}/api/admission/apply`;
